import axios from 'axios';
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {

    getCategories() {
        let msgType = "fetchSuccess";
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/categories")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                let notification = {
                    "msg": "Error while fetching Categories"
                }
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', notification);
                }
            });
    },

    getCategoryMenu() {
        let msgType = "fetchSuccess"; 
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/categories-menu")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                let notification = {
                    "msg": "Error while fetching Categories"
                }
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', notification);
                }
            });
    },
    getCustomViews() {
        let msgType = "fetchSuccess";
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/processEngine/customViewAPI/getCustomViewsList")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error(error)
            })
    },
    getSessionTimeOut() {
        let msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/users/session-timeout")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            });
    },
    verifyCaptcha(captchaResponse) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/standalone/external/verifyCaptcha", { "response": captchaResponse }).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    handleLoginUrl(response, self, redirectUrl) {
        if (response.data.LOGIN_URL) {
            var loginURL = constants.BASE_URL + "/usersgroups/usersAPI/redirectToSecure";
            self.$store.dispatch("fetchLoginUrl", loginURL);
        }
    },
    handleEmptyCSRF(self, redirectUrl) {
        let urlReloaded = localStorage.getItem("urlReloaded");
        var returnUrl = localStorage.getItem("returnUrl");
        
        localStorage.setItem(
            "oldURL", returnUrl != null ? returnUrl : self.$router.currentRoute.path
        );
        if (urlReloaded == null) {
            localStorage.setItem("urlReloaded", "urlReloaded");
            window.location = redirectUrl + "/usersgroups/usersAPI/redirectToSecure";
            return;
        }
        localStorage.removeItem("urlReloaded");
        window.location = self.$store.getters.getLoginUrl;
    },

    handleEmptyCSRFForStandAlone(self) {
        var returnUrl = localStorage.getItem("returnUrl");
        localStorage.setItem(
            "showedBPMTour",
            "false"
        );
        localStorage.setItem(
            "oldURL", returnUrl != null ? returnUrl : self.$router.currentRoute.path
        );
        
        localStorage.removeItem("urlReloaded");
        window.location = self.$store.getters.getLoginUrl;
    },
    handleUnAuthorized(self, response) {

        axios.defaults.headers.common["X-CSRF-TOKEN"] = response.data.CSRF;
        self.$router.push(
            process.env.VUE_APP_CONTEXT_PATH + "/unauthorizedError"
        );
    },
    getThemeData() {
        let msgType = "fetchSuccess";
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/admin/themes-api")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                let notification = {
                    "msg": "Error while fetching theme data"
                }
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', notification);
                }
            });
    }
};